import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AccountService } from '../../../account/account.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SaqueCopiaColaService } from '../saque-copia-cola.service';
import { SaqueCopiaColaModel } from '../saque-copia-cola.model';
import { AuthService } from '../../../../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import { FormatCurrencyPipe } from 'src/app/shared/pipes/formatCurrency.pipe';

@Component({
  selector: 'app-saque-copia-cola',
  templateUrl: './saque-copia-cola.component.html',
  styleUrls: ['./saque-copia-cola.component.scss'],
  providers: [FormatCurrencyPipe]
})
export class SaqueCopiaColaComponent {
  saque = new FormGroup({
    tipoChave: new FormControl<string>('', Validators.required),
    chavePix: new FormControl<string>('', Validators.required),
    valorSolicitado: new FormControl<number | null>(null, [
      Validators.required,
      Validators.min(10),
    ]),
    taxa: new FormControl<number>(0),
    valorTotal: new FormControl<number>(0),
    documentoRecebedor: new FormControl<string>('', Validators.required),
  });

  public saldoDisponivel: string = '';
  public withDrawTaxValue: number = 0;
  public withDrawTaxPercent: number = 0;

  public placeholderValue: string;

  public isSubmitted: boolean;
  public documentFeedBack: string;
  public chavePixFeedBack: string;
  public valorFeedBack: string;
  public documentoFeedBack: string;


  public isLoaded: boolean = true;
  public openConfirm: boolean;
  public errorMessage: string;
  public validationCode: string;
  public dictResponse: any;
  public validatingTotp: boolean = false;

  @ViewChild('requestTOTPCode') validateToken: ElementRef | any;

  constructor(
    private accountService: AccountService,
    private saqueCopiaColaService: SaqueCopiaColaService,
    private authService: AuthService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private fmt: FormatCurrencyPipe
  ) {
    this.getAccountValues();
    this.isSubmitted = false;
    this.documentFeedBack = '';
    this.chavePixFeedBack = '';
    this.valorFeedBack = '';
    this.documentoFeedBack = '';
    this.placeholderValue = '';
    this.errorMessage = '';
    this.validationCode = '';
    this.openConfirm = false;
  }


  getAccountValues() {
    this.accountService.getAccount().then((value) => {
      this.saldoDisponivel = value.readyAmount;
      this.withDrawTaxValue = value.withdrawTaxValue;
      this.withDrawTaxPercent = value.withdrawTaxPercent;
      this.getPlaceHolder();
    });
  }

  async paste(): Promise<void> {
    try {
      const text = await navigator.clipboard.readText();

      this.saque.controls.chavePix.setValue(text.trim());

    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  async pasteTotpCode(): Promise<void> {
  try {
    this.validationCode = (await navigator.clipboard.readText()).trim();
  } catch (err) {
    console.error('Erro ao colar o código:', err);
  }
}

  getPlaceHolder() {
    const bruto   = Number(this.saldoDisponivel);
    let disponivel = (bruto - this.withDrawTaxValue) /
                     (1 + this.withDrawTaxPercent / 100);
    if (disponivel < 0) disponivel = 0;
    this.placeholderValue = this.fmt.transform(disponivel); 
  }

  valorSolicitadoChanged() {
    let valor = Number(
      Number(this.saque.controls.valorSolicitado.value).toFixed(2)
    );
    let taxa = (valor * this.withDrawTaxPercent) / 100;
    taxa = Number(taxa.toFixed(2)) + this.withDrawTaxValue;
    let valorTotal = valor > 0 ? valor + taxa : 0;
    this.saque.controls.taxa.setValue(taxa);
    this.saque.controls.valorTotal.setValue(valorTotal);
  }

  makeWithdraw() {

    // if (!this.formIsValid()) {
    //   this.isLoaded = true;
    //   return;
    // }

    if(this.authService.isReadOnly()){
      this.toastr.error('Seu usuário não tem permissão para realizar essa operação!','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    this.modalService.open(this.validateToken, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'sm',
    });
  }

  public clearForm() {
    this.saque.reset();
    this.accountService.getAccount().then((value) => {
      this.saldoDisponivel = value.readyAmount;
      this.withDrawTaxValue = value.withdrawTaxValue;
      this.withDrawTaxPercent = value.withdrawTaxPercent;
      this.getPlaceHolder();
      this.isSubmitted = false;
      this.openConfirm = false;
    });
  }

  public formIsValid(): boolean {

    this.isSubmitted = true;

    if (this.saque.controls.valorSolicitado.hasError('min')) {
      this.valorFeedBack = 'Valor inválido - Valor mínimo R$ 10,00!';
    } else if (this.saque.controls.valorSolicitado.invalid) {
      this.valorFeedBack = 'Valor é obrigatório!';
    }

    if (this.saque.controls.chavePix.invalid) {
      this.chavePixFeedBack = 'Chave pix obrigatória!';
    }

    // if(this.saque.controls.documentoRecebedor.value!.length === 11 && !cpf.isValid(this.saque.controls.documentoRecebedor.value!) ||
    //    this.saque.controls.documentoRecebedor.value!.length === 14 && !cnpj.isValid(this.saque.controls.documentoRecebedor.value!))
    // {
    //   this.saque.controls.documentoRecebedor.setErrors(Validators.required)
    //   this.documentoFeedBack = 'Documento inválido!';
    // }
    if(this.saque.controls.documentoRecebedor.hasError('required')){
      this.documentoFeedBack = 'Documento é obrigatório!';
    }

    return this.saque.valid;
  }

  async validateTotp() {

    if (this.validatingTotp) {           
      return;
    }
    
    this.validatingTotp = true;

    if (await this.isValidTotp()) {

      this.isLoaded = false;
      this.modalService.dismissAll();

      let saqueCopiaColaModel = new SaqueCopiaColaModel();
      saqueCopiaColaModel.person.pixKeyTypes = 'PIXPASTE';
      saqueCopiaColaModel.person.pixKey = this.saque.controls.chavePix.value!;
      saqueCopiaColaModel.value = this.saque.controls.valorSolicitado.value!;
      // saqueCopiaColaModel.person.cpf = this.saque.controls.documentoRecebedor.value!;
      firstValueFrom(this.saqueCopiaColaService.sendWithdraw(saqueCopiaColaModel))
        .then((value) => {

          if(value.isSend)
          {
            this.toastr.success(
              `Solicitação de saque realizada com sucesso! Transação: ${value.id}`,
              'Sucesso',
              {
                timeOut: 3000,
                positionClass: 'toast-center-center',
              }
            );
          }
          else
          {
            this.toastr.warning(
              `Solicitação de saque em analise!`,
              'Alerta',
              {
                timeOut: 3000,
                positionClass: 'toast-center-center',
              }
            );
          }

          this.clearForm();
          this.isLoaded = true;
          this.validatingTotp = false;
        })
        .catch((error) => {
          this.toastr.error(error.error.mensagem, 'Erro', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.isLoaded = true;
          this.validatingTotp = false;
        });
    } else {
      this.errorMessage = 'Código de autenticação inválido!';
      this.validatingTotp = false;
    }
  }

  async isValidTotp() {
    let isValid: boolean = false;
    await this.authService
      .validateTotpCode(this.validationCode)
      .then((value) => {
        isValid = value.isValid;
      });
    return isValid;
  }
}
